module.exports = __webpack_public_path__ + "static/media/hip_hop.420167fa.jpg";